var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-toolbar-title',[_c('v-icon',[_vm._v(_vm._s(_vm.$route.meta.icon))]),_vm._v("\r\n        "+_vm._s(_vm.$route.meta.title)+"\r\n      ")],1),_c('v-spacer'),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }